import { render, staticRenderFns } from "./CategoryProductGridSearch.vue?vue&type=template&id=0d8fd139&scoped=true&"
import script from "./CategoryProductGridSearch.vue?vue&type=script&lang=ts&"
export * from "./CategoryProductGridSearch.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryProductGridSearch.vue?vue&type=style&index=0&id=0d8fd139&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8fd139",
  null
  
)

export default component.exports